export default "__VITE_ASSET__BwuKTMCM__"